import { render, staticRenderFns } from "./DialogDashboardGeneralConsentDetail.vue?vue&type=template&id=48d043b8&"
import script from "./DialogDashboardGeneralConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DialogDashboardGeneralConsentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports